module.exports = __webpack_public_path__ + "static/IBMPlexSans-Regular-e3199b2a335644dfd26b3880a11d3757.woff";